import { Component } from '@opten/compiler/metadata/component';
import { Collapse } from '@opten/collapse/initializer';
import getParentOrSelfWithClass from '@opten/dom/get-parent-or-self-with-class';
import addClass from '@opten/dom/add-class';
import removeClass from '@opten/dom/remove-class';

@Component({ className: 'js-search-collapse' })
export class SearchCollapseComponent {
	private _collapse: Collapse;

	get element() {
		return this._element;
	}

	get collapse() {
		return this._collapse;
	}

	constructor(private _element: HTMLElement) {
		this._collapse = new Collapse(_element, {});

		const navigation = getParentOrSelfWithClass(_element, 'navigation');

		if (navigation.classList.contains('is--transparent')) {
			_element.addEventListener('show.opten.collapse', () => {
				addClass(navigation, 'is--open');
				addClass(navigation, 'is--open--search');
			});
			_element.addEventListener('hide.opten.collapse', () => {
				removeClass(navigation, 'is--open');
				removeClass(navigation, 'is--open--search');
			});
		}
	}
}
